
import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "CourseCardsClassroom",
    components: { SsrCarousel },
    props: {
        region: {
            default: 'uk',
            type: String
        }
    },
    computed: {
        ...mapGetters({
            activeModal: 'pages/getActiveModal'
        })
    },
    methods: {
        ...mapActions({
            updateActiveModal: 'pages/updateActiveModal'
        }),
        updateModal(id) {
            this.updateActiveModal(id)
            console.log('Active Modal:', this.activeModal)
        },
        hideModal() {
            this.updateActiveModal(null)
        }
    }
}
